export default __webpack_public_path__ + "static/media/spaceXhub.95eb6f3d.png";